import type { Env } from '@/utils/getBaseUrl'

export const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || 'https://gyym.jp'

export const gyymEnv = (process.env.NEXT_PUBLIC_GYYM_ENV ?? 'local') as Env

/**
 * iOS アプリの App Store 数値 ID (App Store Connect 上の Apple ID)。
 * 未設定ならアプリ誘導ページのストアリンクは表示しない。ストア公開後に Vercel 側で設定する。
 */
export const mobileAppStoreId =
  process.env.NEXT_PUBLIC_MOBILE_APP_STORE_ID || undefined

/**
 * Android アプリの Google Play 上の ID (= package name、本番は com.gyym.gyym_app)。
 * 未設定ならアプリ誘導ページのストアリンクは表示しない。ストア公開後に Vercel 側で設定する。
 */
export const mobilePlayStoreId =
  process.env.NEXT_PUBLIC_MOBILE_PLAY_STORE_ID || undefined
